import { render, staticRenderFns } from "./BorcluVekilList.vue?vue&type=template&id=27afd3ae"
import script from "./BorcluVekilList.vue?vue&type=script&lang=ts"
export * from "./BorcluVekilList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports